import { createSlice } from '@reduxjs/toolkit';

interface DashboardState {
  dashboard_loading: boolean;
  states: Record<string, any> | null;
}

const initialState: DashboardState = {
  dashboard_loading: false,
  states: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardLoading: (state, action) => {
      state.dashboard_loading = action.payload;
    },
    setStates: (state, action) => {
      state.states = action.payload;
    },
  },
});

export const { setDashboardLoading, setStates } = dashboardSlice.actions;

export default dashboardSlice.reducer;
